import { QuestionCircleOutlined, SortDescendingOutlined, SortAscendingOutlined,} from '@ant-design/icons';
import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Button, Input, Pagination, Popconfirm, message } from 'antd';
import { useDeleteRoleById, useRoleList, useStatusRole } from 'hooks/role/roles';
import { PAGES, ACTIONS, usePermissions } from 'hooks/permissions/permissions';
import StatusBadge from 'components/statusBadge';
import { statusColor, PAGE_SIZE_OPTIONS, DEFAULT_PAGE_SIZE } from "helpers/commonFunctions";
import { Link } from 'react-router-dom';
import Image from 'helpers/Image';
import "../style.css";
import TableStateRow from "components/tableState";

const Roles = () => {

    const { can } = usePermissions();
    const canAdd = can(PAGES.ROLES, ACTIONS.ADD);
    const canEdit = can(PAGES.ROLES, ACTIONS.EDIT);
    const canDelete = can(PAGES.ROLES, ACTIONS.DELETE);
    const canViewUsers = can(PAGES.USER, ACTIONS.VIEW);
    const showActions = canEdit || canDelete;
    const columnCount = showActions ? 4 : 3;

    const [page, setPage] = useState(DEFAULT_PAGE_SIZE);
    const [pageNumber, setPageNumber] = useState(0);
    const [searchKey, setSearchKey] = useState("");
    const [rolesList, setRolesList] = useState([]);
    const [defaultCall, setDefaultCall] = useState(false);
    const [sortField, setSortField] = useState("");
    const [sortMethod, setSortMethod] = useState("desc");
    const [initialValue, setInitialValue] = useState({
        searchKey: searchKey,
        pageNumber: pageNumber,
        pageSize: page,
        sortField: "",
        sortMethod: ""
    });
    const { mutate: getRole, data: getRolesDetails, isLoading: loading } = useRoleList();
    const { mutate: deleteRole, isLoading: deleteLoading } = useDeleteRoleById();
    const { mutate: statusChange } = useStatusRole();

     const [sorting, setSorting] = useState({
            "r.role_name": null,
            "r.active": null,

        });

    const onFetchRole = (values) => {
        const formData = JSON.stringify(values);
        getRole(formData, {
            onSuccess: (data) => {
                setRolesList(data?.data?.content);
            },
        });
    };
    const handleConfirmActive = (id) => {
        statusChange(id, {
            onSuccess: (item) => {
                if (item.statusCode === 200) {
                    message.success(item.message);
                    onFetchRole(initialValue);
                }
                else {
                    message.error(item?.message);
                }
            },
        });
    }
    const onChange = (page) => {
        initialValue.pageNumber = page - 1;
        setInitialValue(initialValue);
        setPageNumber(page - 1);
    };

    const onShowSizeChange = (current, pageSize) => {
        setPage(initialValue.pageSize = pageSize)
    }

    const searchHandler = (e) => {
        initialValue.searchKey = e.target.value;
        let data = { ...initialValue };
        data.searchKey = e.target.value;
        data.pageNumber = e.target.value !== "" ? 0 : initialValue.pageNumber;
        setInitialValue(data);
        setSearchKey(e.target.value);
    };

    const onSortChange = async (column) => {
        initialValue.pageNumber = 0;
        initialValue.sortField = column;
        initialValue.sortMethod = sorting[column] === 'asc' ? 'desc' : 'asc';
        setPageNumber(0);
        const newSorting = {
            ...sorting,
            [column]: sorting[column] === 'asc' ? 'desc' : 'asc',
        };
        setSorting(newSorting);
        setInitialValue(initialValue);
        setSortField(column);
        setSortMethod(newSorting[column]);
        setRolesList([]);
    };

    const deleteId = (id) => {
        deleteRole(id, {
            onSuccess: (item) => {
                if (item.statusCode === 200) {
                    message.success(item.data);
                    onFetchRole(initialValue);
                }
                else {
                    message.error(item?.data);
                }
            },
        });
    }
    useEffect(() => {
        setDefaultCall(true);
    }, [])
    useEffect(() => {
        if (defaultCall) {
            onFetchRole(initialValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultCall, pageNumber, searchKey, page,sortField,sortMethod]);

    return (
        <Fragment>
            <div className="common-head">
                <div className="title">
                    <Row className="backArrow">
                        {canViewUsers ? <Link to="/admin"><Image className="back-arrow" name="backArrow.svg" /></Link> : null}
                        <h1>Roles</h1>
                    </Row>
                    <p>Manage Roles</p>
                </div>
                <div className="txt-right">
                    {!canAdd ? null : <Link to="/admin/roles/create">
                        <Button><Image name="plus.png" /> Add role</Button>
                    </Link>}
                    <Input onChange={searchHandler} className='report-search' placeholder='Search' prefix={<Image className="search-img" name={"search.svg"} />} allowClear />
                </div>
            </div>
            <div className="common-table">
                <table>
                    <thead>
                        <tr>
                            <th>Designation {sorting["r.role_name"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("r.role_name")} /> : <SortDescendingOutlined onClick={() => onSortChange("r.role_name")} />} </th>
                            <th>Total users</th>
                            <th>Status {sorting["r.active"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("r.active")} /> : <SortDescendingOutlined onClick={() => onSortChange("r.active")} />}</th>
                            {showActions ? <th>Action</th> : null}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <TableStateRow colSpan={columnCount} loading />
                        ) : rolesList == null || rolesList === undefined || rolesList?.length === 0 ? (
                            <TableStateRow colSpan={columnCount}>No roles found</TableStateRow>
                        ) : rolesList.map((item, a) => (
                                <tr key={a}>
                                    <td>{item?.roleName}</td>
                                    <td>{item?.userCount}</td>
                                    {/* <td><button className={statusColor(item?.active)}>{item?.active === true ? "Active" : "Inactive"}</button></td> */}
                                    <td>
                                        {canEdit ? <Popconfirm title={`Are you sure you want to ${item?.active === true ? "inactivate" : "activate"} this ${item?.roleName}?`}
                                            onConfirm={() => handleConfirmActive(item.roleId)}
                                            icon={
                                                <QuestionCircleOutlined />
                                            }
                                            okText="Yes"
                                            cancelText="No">
                                            <button className={statusColor(item.active)}>
                                                {item?.active ? "Active" : "InActive"}
                                            </button>
                                        </Popconfirm> : <StatusBadge active={item?.active} />}
                                    </td>
                                    {showActions ? <td>
                                        {!canEdit ? null : <Link to={`/admin/roles/${item?.roleId}`} state={item}>
                                            <Image name="edit.png" />
                                        </Link>}
                                        {!canDelete ? null : <Popconfirm Loading={deleteLoading}
                                            title={`Are you sure to delete ${item?.roleName}?`}
                                            onConfirm={() => deleteId(item?.roleId)}
                                            icon={
                                                <QuestionCircleOutlined />
                                            }
                                            okText="Yes"
                                            cancelText="No">
                                            <Image name="delete.png" />
                                        </Popconfirm>}
                                    </td> : null}
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            <Row className="table-pagination">
                <Col md={12}>
                    <h5>Showing {pageNumber === 0 ? 1 : (getRolesDetails?.data?.pageable?.offset + 1 || 0)} to {page === 0 ? (getRolesDetails?.data?.pageable?.offset + rolesList?.length || 0) : (getRolesDetails?.data?.pageable?.offset + getRolesDetails?.data?.numberOfElements || 0)} of {getRolesDetails?.data?.totalElements} entries</h5>
                </Col>
                <Col md={12} className="txt-right">
                    {getRolesDetails?.data?.content?.length === 0 ? null : <Pagination pageSize={page} showSizeChanger pageSizeOptions={PAGE_SIZE_OPTIONS} onChange={onChange} current={pageNumber + 1} onShowSizeChange={onShowSizeChange} total={getRolesDetails?.data?.totalElements} />}
                </Col>
            </Row>
        </Fragment >
    )
}

export default Roles;
